import { css } from "lit";

export const dimensionStyles = css`
        ul {
            list-style-type: none;
            margin-top: 0;
            margin-bottom: 10px;
            padding-left: 0;
        }
        li {
            break-inside: avoid;
        }
        input {
            width: 20px;
            height: 20px;
            min-width: 20px;
            min-height: 20px;
        }
        a {
            cursor:pointer;
        }
        .hovered, .select-group-button:hover + ul input {
            filter: drop-shadow(0 0 2px var(--main-blue));
        }
        .select-all{
            margin-bottom: 15px;
            user-select: none;
        }
        .maaling-container {
          overflow-x: auto;
          padding: 20px 55px 30px;
        }
        .maaling-container.error-border {
            border: thin solid var(--main-red);
        }

        span {
            display:table-cell; 
        }
        label {
            padding-left: 28px;
            display:table-cell;
            vertical-align: middle;
        }
        input{
            cursor: pointer;
        } 

        @media only screen and (max-width: 991px) {
            ul {
                margin-top: 10px;
                margin-bottom: 10px;
            }
            li {
                margin-bottom: 10px;
            }
        }
        @media only screen and (max-width: 375px) {
            .maaling-container {
                padding: 5px;
            }
            ul.collapsible-container{
                padding-left: 20px;
            }
        }
`;